import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import {
  DetailRow,
  DetailSection,
  DetailValue,
} from '../../../../components/ui/detailRow/detailRow.component';
import { useAuthContext } from '../../../../contexts/auth';
import { basicInfoContainerStyle } from '../../../../styles/commonStyles';
import { formatDate } from '../../../../utils';
import styles from './tenantBasicInfo.module.css';

export const TenantBasicInfo = () => {
  const { t } = useTranslation();
  const { currentUser, currentUserLoading } = useAuthContext();
  const tenant = currentUser?.tenant;

  if (currentUserLoading || !tenant) {
    return (
      <Box className={styles.loadingContainer}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={basicInfoContainerStyle}>
      <DetailSection title={t('Workspace')}>
        <DetailRow
          label={t('State')}
          value={
            <Chip
              size="small"
              color={tenant.is_active ? 'success' : 'warning'}
              variant={tenant.is_active ? 'filled' : 'outlined'}
              label={tenant.is_active ? t('Active') : t('Inactive')}
              sx={{ fontWeight: 600 }}
            />
          }
        />
        {!tenant.is_active && (
          <DetailRow
            label={t('Scheduled termination date')}
            value={
              <DetailValue>
                {tenant.termination_date ? formatDate(tenant.termination_date) : t('Not scheduled')}
              </DetailValue>
            }
          />
        )}
        <DetailRow label={t('Name')} value={<DetailValue>{tenant.name || '—'}</DetailValue>} />
        <DetailRow label={t('Website')} value={<DetailValue>{tenant.website || '—'}</DetailValue>} />
        <DetailRow
          label={t('Logo')}
          noBorder
          value={
            tenant.logo ? (
              <Box
                component="img"
                src={tenant.logo}
                alt={t('Company logo')}
                sx={{
                  display: 'block',
                  maxWidth: '180px',
                  maxHeight: '64px',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <DetailValue>—</DetailValue>
            )
          }
        />
      </DetailSection>

      <DetailSection title={t('Company registration')}>
        <DetailRow label={t('NIP')} value={<DetailValue>{tenant.nip || '—'}</DetailValue>} />
        <DetailRow label={t('REGON')} value={<DetailValue>{tenant.regon || '—'}</DetailValue>} />
        <DetailRow label={t('KRS')} value={<DetailValue>{tenant.krs || '—'}</DetailValue>} />
        <DetailRow label={t('PESEL')} value={<DetailValue>{tenant.pesel || '—'}</DetailValue>} noBorder />
      </DetailSection>
    </Box>
  );
};
